import { arrayOf, objectOf } from "@altostra/type-validations";
import { number } from "@altostra/type-validations/lib/primitives";

import { isConversationalToolDefinitionResultObject } from "../conversationalToolDefinitionId";

export const isConversationalToolDefinitionsResult = objectOf({
  hits: number,
  results: arrayOf(isConversationalToolDefinitionResultObject),
});
